import { render, staticRenderFns } from "./TablesSetup.vue?vue&type=template&id=294271be&scoped=true&"
import script from "./TablesSetup.vue?vue&type=script&lang=js&"
export * from "./TablesSetup.vue?vue&type=script&lang=js&"
import style0 from "./TablesSetup.vue?vue&type=style&index=0&id=294271be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294271be",
  null
  
)

export default component.exports